import {
  Application,
  Graphics,
  Sprite,
  utils,
  Point,
} from 'pixi.js';
import { clamp } from 'lodash';

class Noise {
  constructor(DOMElement, DOMCanvas) {
    this.DOMElement = DOMElement;
    this.DOMCanvas = DOMCanvas;

    utils.skipHello();
    this.app = new Application({
      view: this.DOMCanvas,
      resizeTo: this.DOMElement,
      resolution: clamp(devicePixelRatio, 1, 1.5),
      autoDensity: true,
      antialias: true,
      transparent: true,
    });

    this.load().then(() => this.init());

    this.background = new Graphics();
    this.background
      .beginFill(0x000000, 0)
      .drawRect(0, 0, window.innerWidth, window.innerHeight)
      .endFill();
    this.app.stage.addChild(this.background);
  }

  load() {
    const videoElement = document.createElement('video');
    this.video = videoElement;
    videoElement.crossOrigin = 'anonymouse';
    videoElement.autoload = false;
    videoElement.preload = '';
    videoElement.muted = true;
    videoElement.autoplay = true;
    videoElement.loop = true;
    videoElement.src = '/static/textures/noise.mp4';
    return new Promise(resolve => videoElement.addEventListener('canplay', resolve));
  }

  init() {
    this.noiseSprite = Sprite.from(this.video);
    if (window.innerWidth > window.innerHeight) {
      const ratio = window.innerHeight / this.noiseSprite.height;
      this.noiseSprite.scale = new Point(ratio, ratio);
    } else {
      const ratio = window.innerWidth / this.noiseSprite.width;
      this.noiseSprite.scale = new Point(ratio, ratio);
    }
    this.noiseSprite.alpha = 1;
    this.app.stage.addChild(this.noiseSprite);
  }
}

export default Noise;
